 (function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .directive('asyncPanel', asyncPanel);

    function asyncPanel() {
        return {
            restrict: 'E',
            controller: asyncPanelCtrl,
            controllerAs: 'vm',
            scope: {
                // must expose function to refresh panel
                options: '=', // requirement, otherwise we don't know what to do with the panel
                data: '=?',
                refresh: '=?', // for debugging purpose only
                isRefreshing: '=?', // for debugging purpose only
                panel: '=?'
            },
            bindToController: true,
            template: '<div class="async-panel-loading" ng-if="!vm.options.settings.hide_loading"></div>',
        };
    }

    function asyncPanelCtrl(PanelManager, $scope, $element, SodLogger, lodash, $compile, $templateCache) {
        // const vm = this;
        var vm = this;

        // vm = this;

        this.$onInit = function() {
            vm.panel = PanelManager.init($scope, vm.options, vm.data);
            vm.panelState = {};
            vm.panel.syncState(vm);
            vm.panel.run();
        }

        vm.handleRender = handleRender;
        vm.refresh = refresh;
        vm.isRefreshing = isRefreshing;


        $scope.$on('$destroy', function() {
            // console.log('%c Destroying Panel: ' + vm.panel.getId(), 'color: red');
            PanelManager.destroy(vm.panel.getId());
        });

        function refresh() {
            vm.panel.refresh();
        }

        function isRefreshing() {
            return vm.panel.isLoading();
        }

        function handleRender() {
            let template;

            if (lodash.has(vm.panelState, 'structure')) {
                if (lodash.has(vm.panelState,'structure.template')) {
                    template = vm.panelState.structure.template;
                }
                if (!lodash.has(vm.panelState, 'structure.template') && lodash.has(vm.panelState, 'structure.templateUrl')) {
                    template = $templateCache.get(vm.panelState.structure.templateUrl);
                }
                // SodLogger.debug('Rendering Template', vm, vm.panelState, template);
            }

            if (vm.panel && vm.panel.destroyCompileElement)
                vm.panel.destroyCompileElement();
            if (template && template.length > 0) {
                $element.html(template);
                vm.panel.setCurrentScope($scope.$new());
                const compileElementRef = $compile($element.contents())(vm.panel.getCurrentScope());
                vm.panel.setCompileElement(compileElementRef);
            }
        }
    }
})();
